rdefine('app/products/properties/qrcode',['backbone','text!products/prop/qrcode.html'],function(Backbone,template) {
    return Backbone.Ribs.View.extend({
        bindings:{
            '.form-control':{
                attr:{
                    placeholder:'model.name'
                },
                value:{
                    events:'change keyup',
                }
            }
        },
        prev:{abort:function(){}},
        pid:0,
        val:'',
        initialize:function(options) {
            this.cform = options.cform;
            this.$el.append(Template7.compile(template)());
            this.bindings['.form-control'].value.data = 'cform.property_'+this.model.get("id");
            this.cform.on('change:property_'+this.model.get('id'),this.updateCodeExample.bind(this));
            this.pid = options.product_id;
            _.defer(_.bind(this.updateCodeExample,this));
        },
        updateCodeExample:function() {
            this.val = this.cform.get('property_'+this.model.get('id'));

            var e = false;
            switch(window.qrcodetype){
                case "ean":
                    e = this.renderEan();
                    break;
                case "qr":
                    e =this.renderQR();
                    break;
            }
            if(e) {
                this.$el.find(".place-example").html("").append(e);
            }else if(!this.val || this.val.length===0) {
                this.$el.find(".place-example").html("");
            }
            this.checkAvail();
        },
        renderEan:function() {
            var e = $('<img/>');
            try {
                JsBarcode(e[0], this.$el.find("input").val(), {
                    format: 'CODE128',
                    height: 60,
                });
            } catch(e) {
                return false;
            }
            return e;
        },
        renderQR:function() {
            var e = $('<div></div>');
            new QRCode(e[0],{
                text:this.$el.find("input").val(),
                width: 80,
                height: 80,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
            });
            return e;
        },
        checkAvail:function() {
            this.prev.abort();
            this.prev = $.getJSON("/qrscanner/check",{
                product_id:this.pid,
                val:this.val
            },function(resp) {
                console.log(resp);
                if(resp.avail) {
                    this.$el.find('.has-error').removeClass('has-error');
                    this.$el.find('.error-message').remove();
                }else{
                    this.$el.find('.fg-line').addClass('has-error');
                    this.$el.find('.error-message').remove();
                    this.$el.append($('<div class="error-message">'+resp.message+'</div>').css("color","#FF0000"));
                }
            }.bind(this));
        }
    });
});